import React from 'react';
export default React.createContext(null);


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-toastify/node_modules/react-transition-group/esm/TransitionGroupContext.js
// module id = ./node_modules/react-toastify/node_modules/react-transition-group/esm/TransitionGroupContext.js
// module chunks = main